<script>
    export default {
        name: "ScreenCaptionMixin",
        data () {
            return {
                positionClassMap : {
                    "bottom" : "bottom",
                    "center" : "center",
                    "top" : "top"
                },
            }
        },
        mounted () {
            if (this.myData) {
                // Adding watcher on myData after myData is created.
                // If watcher is set on instantiation, it asks for myData before handleRegistration finishes.
                // At that point sectionId is not set yet, so sectionData returns an empty object.
                this.$watch('myData.responsiveScreenCaptionPositionClass', function (oldData, newData) {
                    if (typeof oldData === 'undefined' && typeof newData === 'undefined') {
                        return;
                    }
                    const responsiveScreenCaptionPositionClass = newData;
                    if (responsiveScreenCaptionPositionClass && responsiveScreenCaptionPositionClass[this.activeDevicePreview]) {
                        this.updateScreenCaptionPositionClass(responsiveScreenCaptionPositionClass[this.activeDevicePreview]);
                    }
                }, {deep: true});
            }
            // push responsive functions to nodeState
            this.responsiveFunctions.push('updateScreenCaptionPositionClassForDevice');
        },
        computed: {
            referenceNodeScreenCaption () {
                return this.myNode.querySelector(".js-screen-caption") || null;
            },
        },
        methods: {
            getScreenCaptionDisplay () {
                if (this.referenceNodeScreenCaption) {
                    return this.getStyleProperty("display",{defaultValue:""},this.referenceNodeScreenCaption) || false;
                }
                return false;
            },
            getScreenCaptionBackgroundColor () {
                return this.getStyleProperty('backgroundColor',{ defaultValue : "" }, this.referenceNodeScreenCaption);
            },
            getScreenCaptionPosition () {
                return this.getKeyForMatchingClass(this.positionClassMap, {defaultValue:"bottom"},this.referenceNodeScreenCaption);
            },

            setScreenCaptionPosition (eventData) {
                let responsiveScreenCaptionPositionClass = this.myData.responsiveScreenCaptionPositionClass;
                if (!responsiveScreenCaptionPositionClass['desktop']) {
                    responsiveScreenCaptionPositionClass['desktop'] = this.positionClassMap[this.getScreenCaptionPosition()];
                }
                responsiveScreenCaptionPositionClass[this.activeDevicePreview] = this.positionClassMap[eventData.value];
                this.changeMyData({responsiveScreenCaptionPositionClass});
            },
            setScreenCaptionDisplay (eventData) {
                const value = (eventData.value) ? "block": "none";
                this.applyStyle({ styleProp : 'display' , value : value, targetSelector: ".js-screen-caption"});
            },
            setScreenCaptionBackgroundColor (value) {
                this.applyStyle({ styleProp : 'backgroundColor' , value : value, targetSelector: ".js-screen-caption"});
            },
            updateScreenCaptionPositionClassForDevice (device, node) {
                const responsiveScreenCaptionPositionClass = this.myData.responsiveScreenCaptionPositionClass;

                if (responsiveScreenCaptionPositionClass) {
                    let newClass = false;
                    if (responsiveScreenCaptionPositionClass[device]) {
                        newClass = responsiveScreenCaptionPositionClass[device];
                    } else if (responsiveScreenCaptionPositionClass['desktop']) {
                        newClass = responsiveScreenCaptionPositionClass['desktop'];
                    }
                    if (newClass) {
                        this.updateScreenCaptionPositionClass(newClass, node);
                    }
                }
            },
            updateScreenCaptionPositionClass (newClass, node) {
                let newData = {
                    newClass : newClass,
                    classesToRemove : Object.keys(this.positionClassMap),
                    update : true
                }
                const screenCaptionNode = node ? node.querySelector(".js-screen-caption") : this.referenceNodeScreenCaption;
                this.applyClass(newData, screenCaptionNode);
            }
        },
        watch: {
            activeDevicePreview: {
                handler () {
                    this.updateScreenCaptionPositionClassForDevice(this.activeDevicePreview);
                }
            }
        }
    }
</script>